import { BookingAvailabilitySlot } from '../types';

const normalizeTime = (value: string | null | undefined) => String(value || '').trim();

export const pickPreferredAvailableTime = ({
  currentTime,
  slots
}: {
  currentTime?: string | null;
  slots: BookingAvailabilitySlot[];
}) => {
  const availableTimes = (slots || [])
    .filter((slot) => slot.available)
    .map((slot) => normalizeTime(slot.time))
    .filter(Boolean);

  const normalizedCurrentTime = normalizeTime(currentTime);
  if (normalizedCurrentTime && availableTimes.includes(normalizedCurrentTime)) {
    return normalizedCurrentTime;
  }

  return availableTimes[0] || '';
};
